import { put } from "redux-saga/effects";
import { ApiCaller, Utils } from "../../config";
import { AdsAction } from "../actions";

export default class AdsMiddleware {
  static *GetAdsListing({ payload, cb }) {
    console.log(payload, "payloaddddddd");

    try {
      const { limit = 10, offset = 0, keyword = "", status = "", type } = payload;
      let res = yield ApiCaller.Get(
        `/ads?offset=${offset}&keyword=${keyword}&limit=${limit}&status=${status}&type=${type}`
      );
      if (res.status == 200) {
        yield put(AdsAction.getAdsListingSuccess(res.data.data));

        if (cb) {
          cb();
        }
      } else {
        yield put(AdsAction.getAdsListingFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(AdsAction.getAdsListingFailure());
      //   Utils.showSnackBar({
      //     message: "Reset password failed",
      //     severity: "error",
      //   });
    }
  }

  static *DeleteAds({ id, cb }) {
    try {
      let res = yield ApiCaller.Delete(`/ad/${id}`);
      if (res.status == 200) {
        yield put(AdsAction.deleteAdsSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message,
        });
        if (cb) {
          cb();
        }
      } else {
        yield put(AdsAction.deleteAdsFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(yield put(AdsAction.deleteAdsFailure()));
    }
  }

  static *EditAds({ data, cb }) {
    try {
      const { id } = data;
      const formdata = new FormData();
      if (data.file) {
        formdata.append("file", data.file);
      }
      formdata.append("end_date", data.end_date);

      let res = yield ApiCaller.Post(`/ad/${id}`, formdata);
      if (res.status == 201) {
        yield put(AdsAction.editAdsSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message,
        });
        if (cb) {
          cb(res);
        }
      } else {
        yield put(AdsAction.editAdsFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(yield put(AdsAction.editAdsFailure()));
    }
  }

  static *CreateAds({ data, cb }) {
    try {
      const formdata = new FormData();

      if (data.file) {
        formdata.append("file", data.file);
      }
      formdata.append("start_date", data.start_date);
      formdata.append("end_date", data.end_date);
      formdata.append("title", data.title);
      formdata.append("description", data.description);
      formdata.append("receipt_data", data.receipt_data);
      formdata.append("transaction_id", data.transaction_id);
      formdata.append("payment_method", data.payment_method);
      formdata.append("paid", data.paid);

      let res = yield ApiCaller.Post(`/ad/create`, formdata);
      if (res.status == 201 || res.status == 200) {
        yield put(AdsAction.createAdsSuccess(res.data.data));
        Utils.showSnackBar({
          message: res.data.message || "Ad created successfully",
        });
        if (cb) {
          cb(res);
        }
      } else {
        yield put(AdsAction.createAdsFailure(res.data.message));
        Utils.showSnackBar({
          message: res.data.message,
          severity: "error",
        });
      }
    } catch (err) {
      yield put(AdsAction.createAdsFailure());
      Utils.showSnackBar({
        message: "Failed to create ad",
        severity: "error",
      });
    }
  }
}
